import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text } from "@nbs/ui";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section className="nbs-page-state">
      <span className="nbs-bare__glyph" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 4c3.5 2 6 5 6 9a6 6 0 0 1-12 0c0-4 2.5-7 6-9Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path
            d="M12 19V11m0 2.5 2.2-1.5M12 16l-2-1.3"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <Heading level={1}>{t("pages.notFoundTitle")}</Heading>
      <Text tone="muted">{t("pages.notFoundBody")}</Text>
      <Link to="/">
        <Button variant="primary">{t("pages.goHome")}</Button>
      </Link>
    </section>
  );
}
